import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import store from 'app/store'
import { Provider } from 'react-redux'
import { isIE, isMac, renderIE } from './utils/browserUtils'
import App from './App'
import MatrixErrorBoundary from './app/MatrixErrorBoundary'

if (isIE()) {
  renderIE()
} else {
  if (isMac()) {
    document.documentElement.classList.add('os_mac')
  }
  ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
      <Provider store={store}>
        <MatrixErrorBoundary>
          <App />
        </MatrixErrorBoundary>
      </Provider>
    </BrowserRouter>
  )
}
